import { render, staticRenderFns } from "./TotalCount.vue?vue&type=template&id=7096968c&"
import script from "./TotalCount.vue?vue&type=script&lang=js&"
export * from "./TotalCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports